import { render, staticRenderFns } from "./EmailTemplates.vue?vue&type=template&id=67b7aa55"
import script from "./EmailTemplates.vue?vue&type=script&setup=true&lang=js"
export * from "./EmailTemplates.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports